<!--temporary breadcrumbs-->
<template>
  <v-container fluid class="breadcrumb pa-0">
    <v-container class="py-0 text-decoration-none fill-height">
    <span v-for="(breadcrumb, index) in breadcrumbs" :key="index">
      <span v-if="index < breadcrumbs.length - 1">
        <NuxtLink :to="{ path: breadcrumb.path }" class="text-decoration-none text-primary pb-0">
          {{ breadcrumb.title }}
        </NuxtLink>
        <span class="text-lighttext pr-1"> / </span>
      </span>
      <span v-else class="text-lighttext">
        <NuxtLink :to="{ path: breadcrumb.path }" class="text-decoration-none text-primary pb-0">
         {{ breadcrumb.title }}
        </NuxtLink>
      </span>
    </span>
    </v-container>
  </v-container>
</template>

<script setup>

const dataAll = useDataAll()
const { $methods, $PAG,$helpers } = useNuxtApp()
const router = useRouter()
const history = router.options.history
const { nameMenu } = useNameMenuStore();
const route = useRoute()
const breadcrumbs = ref([]);
const isMounted = ref(false)
const siteSettings = useSiteSettingsStore();
const pageOverview = usePageOverviewStore();
const currentProduct = useCurrentProductStore()
const NVEAR_PAGE_TYPES = { 1: 'DN', 2: 'DE', 3: 'DV', 4: 'DA', 5: 'DR' }
const reservedPathParts = {"filter":1,"compare":1}
watch(
  [() => route.fullPath, () => currentProduct.productData],
  () => updateList(),
  { immediate: true }
)
onMounted(() => { isMounted.value = true; updateList() })


function updateList() {
  const slugSegments = [route.params.slug ?? []].flat()
  const routeEntries = Object.entries(slugSegments)
  const isArticlePath = slugSegments.includes(ARTICLE_PATH)

  if ( isArticlePath ){
    // make Breadcrumb for productpage

    // check if a PAG page is in the history
    const isHistoryPagPage = $PAG.isHistoryPagPage(history)

    // get product name from URL
    const productNameInUrl = routeEntries.at(-1)?.[1]

    // retrieve histroy path if possibele
    const historyPath = isMounted.value ? (history.state?.back ?? '') : ''
    let urlForBreadcrumb = ''
    if (isHistoryPagPage && historyPath != ''){
      // use history Path for breadcrumb
      urlForBreadcrumb = historyPath
    } else {
      // use first Page in product with page id for breadcrumb
      urlForBreadcrumb =getFirstPagSiteFromSite() 
    }
    // split urlForBreadcrumb in segments  
    const urlSegments = urlForBreadcrumb.split(/[?#]/)[0].split('/').filter(Boolean)   
    // add product to urlSegments
    if (productNameInUrl) urlSegments.push(productNameInUrl)
    makeBreadcrumbOfUrl(Object.entries(urlSegments), true)

  } else {
    // make breadcrumb of nog product page
    makeBreadcrumbOfUrl(routeEntries, false)
  }
}

function makeBreadcrumbOfUrl(RouteEntries, articleUrl){ 
  let path = "";

  breadcrumbs.value = []
  let nvearIdLastUse = 0;
  if (getYesNo(siteSettings, 'HomePageShowHeadMenu')){ 
    path = addBreadCrumb('',"Home",path)
  }

  for (const [key, value] of RouteEntries) {
    const nvearId = isNVEARString(value)
    const pageType = NVEAR_PAGE_TYPES[nvearId]

    if (pageType) {
      const page = pageOverview.getPageByType(pageType)
      if (page) {
        path = addBreadCrumb(page.NameUrl, page.NameMenu, path)
      }
      nvearIdLastUse = nvearId
    } else if (!dataAll.getLanguages().some((i) => i.toLowerCase() == value.toLowerCase())) {  
      // nvearIdLastUse > 0 => nvear search
      if (isReservedPathParts(value)){
        // if reservedPathParts occurs in uri jump out the for loop
        break;
      }

      if (nvearIdLastUse ==0) {
        // search page JSON from Webpages, recursed

        let pageContent =$methods.pageByCodeField(pageOverview.PageOverview, value, "NameUrl");
        if (pageContent){
          path = addBreadCrumb(value,pageContent.NameMenu,path);     
        } else { // no pagecontent found, so add url in breadcrumb as name. (fe heapens with articles)
          if (Number(key) === RouteEntries.length - 1 && articleUrl ) {
            // article page put the current page in the last breadcrumb
            path = addBreadCrumb("", value, route.fullPath);
          } else { 
            path = addBreadCrumb(value, value, path); 
          }
        }
      } else {
        //search in news, events, vacancies and actions for specifiek uri part, nvearIdLastUse is always the parent form the nvear item
        path = addBreadCrumb(value,nameMenu.value!=""?nameMenu.value:value,path);     
      }
     } 
  }
}

function addBreadCrumb(nameUrl, nameMenu, pathIn){
  const pathAdd = `${pathIn}/${nameUrl}`.replace(/\/{2,}/g, '/')

  let title = String(nameMenu ?? '').replace(/-/g, ' ')
  try {
    title = decodeURIComponent(title)
  } catch {
    // ongeldige %-codering: gebruik de ruwe titel
  }

  if (title) {
    breadcrumbs.value.push({
      title,
      path: $methods.localePath(pathAdd),
    })
  }
  return pathAdd
}

function getFirstPagSiteFromSite(){
  const code = siteSettings.Code
  const pagList = currentProduct.productData?.pag
  if (!code || !pagList?.length) return '/'

  const prefix = code.replace(/_/g, '').toUpperCase()   // wiegeltransport_EU_NL → WIEGELTRANSPORTEUNL
  const pageId = pagList.find(p => p.startsWith(prefix + '_'))
  if (!pageId) return '/'

  return pageOverview.getPageUrlByPageCode(pageId) || '/'
}
function isNVEARString(inString){
  const NVEAROverviewMapping = getNVEAROverviewMapping()
  const key = inString.toLowerCase().trim()
  const keys = Object.keys(NVEAROverviewMapping)
  const index = keys.indexOf(key)
  return index === -1 ? 0 : index + 1
}
function isReservedPathParts(pathPart){
  return $helpers.isset(reservedPathParts[pathPart])
}

</script>
